import React from 'react';
import {
  Route,
} from 'react-router-dom';

import { publicRoutes } from 'components/application/routes/routesConstants';
import { AuthLayout } from '../layouts/auth-layout';

const SignIn = React.lazy(() => import('../../authentication/sign-in/SignIn'));
const InvitationContainer = React.lazy(() => (
  import('../../authentication/invitation/InvitationContainer')
));
const OnboardingContainer = React.lazy(() => (
  import('components/onboarding/OnboardingContainer')
));

export const PublicRoutes: React.FC = () => (
  <Route
    element={<AuthLayout />}
  >
    <Route
      path={publicRoutes.signIn}
      element={<SignIn />}
    />
    <Route
      path={publicRoutes.acceptInvitation}
      element={<InvitationContainer />}
    />
    <Route
      path={publicRoutes.onboarding}
      element={<OnboardingContainer />}
    />
    <Route
      path="*"
      element={<SignIn />}
    />
  </Route>
);

export default PublicRoutes;
